import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/schology/banner-back.webp";

function Banner() {
  return (
    <section
      className="animal-case-banner schology-case-banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "top center",
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={8}
            lg={9}
            xl={8}
            xxl={7}
            className="m-auto text-center"
          >
            <div className="schology-logo">
              <StaticImage
                src="../../../images/case-studies/schology/main-logo.webp"
                alt="TekRevol"
                className="mb-4 mb-md-5"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={350}
                height={66}
              />
            </div>
            <h1 style={{ color: "#111322" }} className="mb-4 mb-md-5">
              <span style={{ color: "#565CCF" }}>Schology</span> Is Transforming
              Education through Innovation
            </h1>
            <div className="animal-banner-img">
              <StaticImage
                src="../../../images/case-studies/schology/banner-img-sch.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1241}
                height={610}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
